import React from 'react'

const Card = ({className, color, title, text}) => {
  return (
    <div className={`card ${className}`} style={{background:"white", color:'black', width:'231px', height:"140px"}}>
      <div className='card-body'>
        <a href='#' className={`card-title fw-bold text-${color} fs-5 mb-3 d-block`}>
          {title}
        </a>
        <div className='py-1'>
          <span className='fs-1 fw-bold'>{text}</span>
        </div>
      </div>
    </div>
  )
}

export {Card}